// GlobalToaster — wraps DS `Toaster` (US-050).
//
// The DS `Toaster` already exposes a module-scoped imperative bus + a Radix
// Provider/Viewport. The web app simply mounts it once with the localised
// viewport label so screen readers announce the live region by name.
//
// DS-GAP-DESIGN (US-050):
//   No additional state context is needed — the DS bus is already process-
//   wide. The wrapper exists purely to thread the i18n label and to reserve a
//   stable mount point we can later extend (e.g., onError handler, telemetry).

import { Toaster } from '@barel/ui';

import { useT } from '@barel/i18n';

export function GlobalToaster() {
  const t = useT('shell');
  return <Toaster label={t('toast.viewportLabel')} />;
}

// Re-export the imperative API so feature code can `import { toast } from '@/features/shell/GlobalToaster'`
// without pulling the whole DS surface.
export { toast, useToast } from '@barel/ui';
